import { defineComponent, computed, createElementBlock, createCommentVNode, openBlock, createVNode, unref, withCtx, createElementVNode, toDisplayString } from "vue";
import { ScalarListbox } from "@scalar/components";
import { ScalarIconCaretUpDown } from "@scalar/icons";
const _hoisted_1 = {
  key: 0,
  class: "document-selector -mb-1 p-3 pb-0"
};
const _hoisted_2 = {
  class: "group/dropdown-label hover:bg-b-2 text-c-2 py-1.75 flex h-8 w-full cursor-pointer items-center rounded border px-2",
  type: "button"
};
const _hoisted_3 = { class: "text-c-1 overflow-hidden text-ellipsis text-base" };
const _sfc_main = /* @__PURE__ */ defineComponent({
  __name: "DocumentSelector",
  props: {
    options: {},
    modelValue: {}
  },
  emits: ["update:modelValue"],
  setup(__props, { emit: __emit }) {
    const emit = __emit;
    const showSelector = computed(() => __props.options && __props.options?.length > 1);
    const listboxOptions = computed(
      () => __props.options?.map((option, index) => ({
        id: String(index),
        // Get the display text for the selected option
        label: option.title || option.slug || `API #${index + 1}`
      })) || []
    );
    const selectedOption = computed({
      get: () => listboxOptions.value.find(({ id }) => id === String(__props.modelValue)),
      set: (opt) => emit("update:modelValue", Number(opt.id))
    });
    return (_ctx, _cache) => {
      return showSelector.value ? (openBlock(), createElementBlock("div", _hoisted_1, [
        createVNode(unref(ScalarListbox), {
          modelValue: selectedOption.value,
          "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event) => selectedOption.value = $event),
          options: listboxOptions.value,
          resize: ""
        }, {
          default: withCtx(() => [
            createElementVNode("button", _hoisted_2, [
              createVNode(unref(ScalarIconCaretUpDown), { class: "mr-1 size-4 text-current" }),
              createElementVNode("span", _hoisted_3, toDisplayString(selectedOption.value?.label || "Select API"), 1)
            ])
          ]),
          _: 1
        }, 8, ["modelValue", "options"])
      ])) : createCommentVNode("", true);
    };
  }
});
export {
  _sfc_main as default
};
//# sourceMappingURL=DocumentSelector.vue.js.map
